import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { constructNow, isAfter, addDays } from 'date-fns';
import FreePoolEvent from '../../assets/images/popups/free-pool-event.webp';
import Close from '../../assets/images/cross_white.svg';

export default function PoolEvent() {
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const closePopup = (days) => {
    setIsOpen(false);
    localStorage.setItem('poolEvent', addDays(constructNow(), days));
  };

  useEffect(() => {
    const lastClose = localStorage.getItem('poolEvent');
    if (!lastClose || isAfter(constructNow(), lastClose)) {
      setIsOpen(true);
    }
  }, []);

  return (
    <div className={`${isOpen ? 'pool-event-popup' : 'popup-hide'}`}>
      <div className="pool-event-container">
        <div className="pool-event-header" onClick={() => closePopup(0)}>
          <img src={Close} width={20} height={20} alt="닫기" />
          <span>닫기</span>
        </div>
        <div className="pool-event-content">
          <div onClick={() => navigate('/pool/event-details')}>
            <img className="pool-event-image" src={FreePoolEvent} alt="수영장 이벤트 안내 이미지" />
          </div>
        </div>
        <div className="pool-event-footer" onClick={() => closePopup(7)}>
          <span>7일간 안보기</span>
        </div>
      </div>
    </div>
  );
}
